import React from 'react';
import { Pnevmatika } from '../../types/pnevmatika';
import { formatPhoneNumber } from '../../utils/phoneUtils';
import { formatDate } from '../../utils/dateUtils';
import { Button } from '../common/Button';
import { printCertificate } from '../../utils/printCertificate';
import './PnevmatikaTable.css';

interface PnevmatikaTableProps {
  pnevmatike: Pnevmatika[];
  onEdit: (pnevmatika: Pnevmatika) => void;
  onDelete: (id: number) => void;
  loading?: boolean;
}

export const PnevmatikaTable: React.FC<PnevmatikaTableProps> = ({
  pnevmatike,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const isOverdue = (dateStr: string) => {
    const stored = new Date(dateStr);
    const now = new Date();
    const eighteenMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 18, now.getDate());
    return stored <= eighteenMonthsAgo;
  };
  if (loading) {
    return <div className="table-loading">Nalaganje...</div>;
  }

  if (pnevmatike.length === 0) {
    return <div className="table-empty">Ni najdenih pnevmatik v shrambi.</div>;
  }

  return (
    <div className="table-container">
      <table className="pnevmatika-table">
        <thead>
          <tr>
            <th>Lastnik</th>
            <th>Telefonska številka</th>
            <th>Oznaka pnevmatike</th>
            <th>Začetek hrambe</th>
            <th>Z platišči</th>
            <th>Tip</th>
            <th>Plačani znesek</th>
            <th>Komplet</th>
            <th>Znamka</th>
            <th>Opomba</th>
            <th>Dejanja</th>
          </tr>
        </thead>
        <tbody>
          {pnevmatike.map((pnevmatika: Pnevmatika) => (
            <tr key={pnevmatika.id} className={isOverdue(pnevmatika.spravljeno_od) ? 'overdue' : ''}>
              <td>{`${pnevmatika.ime} ${pnevmatika.priimek}`}</td>
              <td>{pnevmatika.telefonska_stevilka ? formatPhoneNumber(pnevmatika.telefonska_stevilka) : '-'}</td>
              <td>
                <span className="oznaka-badge">{pnevmatika.oznaka_gume}</span>
              </td>
              <td>{formatDate(pnevmatika.spravljeno_od)}</td>
              <td>{pnevmatika.z_platisci ? 'Da' : 'Ne'}</td>
              <td>{pnevmatika.letna ? 'Letna' : 'Zimska'}</td>
              <td>{Number(pnevmatika.placani_znesek).toFixed(2)}€</td>
              <td>{pnevmatika.komplet}</td>
              <td>{pnevmatika.znamka || '-'}</td>
              <td>{pnevmatika.pripisek || '-'}</td>
              <td>
                <div className="action-buttons">
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => onEdit(pnevmatika)}
                  >
                    Uredi
                  </Button>
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => printCertificate({ ime: pnevmatika.ime, priimek: pnevmatika.priimek, oznaka_gume: pnevmatika.oznaka_gume })}
                  >
                    Natisni potrdilo
                  </Button>
                  <Button
                    variant="danger"
                    size="small"
                    onClick={() => onDelete(pnevmatika.id)}
                  >
                    Odstrani
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
